/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { getFilterConfig } from './GlobalSearchModal.filterConfig';
import GlobalSearchDateRangePicker from './GlobalSearchDateRangePicker';

class GlobalSearchFilterInput extends PureComponent {
    static propTypes = {
        filter: PropTypes.object.isRequired,
        value: PropTypes.any,
        onChange: PropTypes.func.isRequired,
        onComplete: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
    };

    handleDateComplete = (value) => {
        this.props.onComplete(value);
    }

    handleDateCancel = () => {
        this.props.onCancel();
    }

    render() {
        const { filter, value } = this.props;
        const filterConfig = getFilterConfig(filter?.key);

        if (!filterConfig) {
            return null;
        }

        if (filterConfig.isDateRange) {
            return (
                <GlobalSearchDateRangePicker
                    title={filter.text}
                    value={value}
                    onChange={this.handleDateComplete}
                    onClose={this.handleDateCancel}
                    variant="all"
                />
            );
        }

        return null;
    }
}

export default GlobalSearchFilterInput;

